import { useEffect, useState } from 'react';

/**
 * Returns seconds remaining until expiresAt (unix seconds).
 * Falls back to the legacy `timer` value if expiresAt is not provided
 * (backwards-compatible for tests/stories that don't supply it).
 */
const getSecondsRemaining = ({ expiresAt, now, timer }) => {
  if (typeof expiresAt === 'number') {
    return Math.max(expiresAt - Math.floor(now / 1000), 0);
  }
  return Math.max(timer, 0);
};

/**
 * Displays real remaining time derived from `expiresAt` (unix seconds from Redux).
 * Polls Date.now() every second rather than decrementing local state, so the
 * display stays accurate even after browser throttling or sleep.
 */
function CountdownTimer({ timer = 600, expiresAt = null, isOpened = false }) {
  const [now, setNow] = useState(Date.now());

  // Snap to current time immediately when modal opens or expiration changes,
  // preventing a stale value from briefly rendering.
  useEffect(() => {
    setNow(Date.now());
  }, [expiresAt, isOpened, timer]);

  useEffect(() => {
    if (!isOpened) {
      return undefined;
    }

    const increment = setInterval(() => {
      setNow(Date.now());
    }, 1000);

    return () => {
      clearInterval(increment);
    };
  }, [isOpened]);

  const formatTimer = seconds => {
    let displayMinutes =
      Math.floor(seconds / 60) > 9
        ? Math.floor(seconds / 60)
        : `0${Math.floor(seconds / 60)}`;
    let displaySeconds =
      Math.floor(seconds % 60) > 9
        ? Math.floor(seconds % 60)
        : `0${Math.floor(seconds % 60)}`;

    return `${displayMinutes}:${displaySeconds}`;
  };

  const seconds = getSecondsRemaining({ expiresAt, now, timer });
  const timeLeft = formatTimer(seconds);

  return timeLeft;
}

export default CountdownTimer;
